<script setup>
import { useRoute } from '@js/utils/route';
import { ref } from 'vue';

const { ticket, callback } = defineProps({
    ticket: {
        type: Object,
        required: true,
    },
    callback: {
        type: Function,
        required: false,
    },
});

const { route } = useRoute();

const loading = ref(false);

function toggleAction() {
    loading.value = true;

    axios
        .post(
            route('front.projectManagement.task.postToggleTicketValidatedAt', {
                ticket: ticket.id,
            }),
        )
        .then(() => {
            if (callback) {
                callback();
            }
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            loading.value = false;
        });
}
</script>

<template>
    <slot name="button" :action="toggleAction" :loading="loading" />
</template>
